// Shared search logic for Sidebar search + Ctrl/Cmd+K global palette.
// Same data source (sectionsList) → consistent results.

// Synonym table per user spec. Both directions are stored to keep matching
// O(1) at lookup time.
const SYNONYMS = {
  quote:        ["quotation", "estimation"],
  quotation:    ["quote", "estimation"],
  estimation:   ["quote", "quotation"],
  invoice:      ["billing"],
  billing:      ["invoice", "quotation", "proforma"],
  proforma:     ["billing", "invoice"],
  brand:        ["brand master", "catalogue"],
  catalogue:    ["brand", "product", "product management"],
  product:      ["catalogue", "product management"],
  user:         ["user management", "employee"],
  employee:     ["user", "user management", "hr"],
  lead:         ["crm", "lead management"],
  crm:          ["lead", "customer"],
  customer:     ["lead", "crm"],
  purchase:     ["po", "vendor"],
  po:           ["purchase", "vendor"],
  vendor:       ["purchase", "po"],
  service:      ["installation", "field engineer"],
  installation: ["service", "field engineer"],
  hr:           ["employee", "attendance"],
  attendance:   ["hr", "employee"],
};

const expandQuery = (q) => {
  const base = q.trim().toLowerCase();
  if (!base) return [];
  const expanded = new Set([base]);
  // Add direct synonyms of the query
  (SYNONYMS[base] || []).forEach((s) => expanded.add(s));
  // Also tokenize & add synonyms per token (handles "brand master" → brand + master)
  base.split(/\s+/).forEach((tok) => {
    expanded.add(tok);
    (SYNONYMS[tok] || []).forEach((s) => expanded.add(s));
  });
  return Array.from(expanded);
};

/** Returns true if any keyword matches the item's label or path. */
export const itemMatches = (item, keywords) => {
  if (!keywords || keywords.length === 0) return true;
  const hay = `${item.label || ""} ${item.path || ""}`.toLowerCase();
  return keywords.some((k) => hay.includes(k));
};

/**
 * Filter a list of [sectionId, label, items] tuples by a query.
 * Returns the same shape but with non-matching items dropped.
 * If a section's label itself matches, all items are kept.
 */
export const filterSections = (sections, query) => {
  const kws = expandQuery(query);
  if (kws.length === 0) return sections;
  return sections
    .map(([id, label, items, icon]) => {
      const sectionLabelMatches = kws.some((k) => (label || "").toLowerCase().includes(k));
      const filtered = sectionLabelMatches ? items : items.filter((it) => itemMatches(it, kws));
      return [id, label, filtered, icon];
    })
    .filter(([, , items]) => items && items.length > 0);
};

/** Flat list of {section, item} for the Ctrl+K palette. */
export const flattenForPalette = (sections, query = "") => {
  const filtered = filterSections(sections, query);
  const flat = [];
  filtered.forEach(([id, label, items]) => {
    items.forEach((item) => flat.push({ sectionId: id, sectionLabel: label, item }));
  });
  return flat;
};

export { expandQuery };
